/**
 * supabase-js gir `data: null` ved ikke-2xx; selve feilmeldingen ligger i
 * responsbodyen på `error.context` (en Response). Uten dette ser brukeren bare
 * «Edge Function returned a non-2xx status code».
 */
export async function edgeErrorMessage(
  error: unknown,
  data: { error?: string } | null | undefined,
  fallback: string,
): Promise<string> {
  const ctx = (error as { context?: unknown } | null)?.context;
  if (ctx && typeof (ctx as Response).json === "function") {
    try {
      const body = await (ctx as Response).clone().json();
      if (body && typeof body.error === "string" && body.error) return body.error;
    } catch {
      // ikke JSON: fall tilbake under
    }
  }
  return data?.error ?? (error as { message?: string } | null)?.message ?? fallback;
}
